import { z } from 'zod';

import { BoListQueryBase } from '@Common/types/bo/bo_list_query';
import { buildZodBoListQueryParsed } from '@Common/types/bo/utils/build_zod_bo_list_query';
import { ZodId } from '@Common/types/request';
import { createZodArrayable } from '@Common/types/zod/zod-arrayable';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

export const odStatusFilesStatusValues = ['new', 'processed', 'skipped', 'error'] as const;

export const odStatusFilesTypeValues = [
  'acknowledgment',
  'confirmation',
  'aggregated_orders',
  'funds_prices',
  'instruments_update',
  'eod_positions',
  'qs99_confirmation',
  'ca_movements',
  'eod_cash_balances',
] as const;

const ZodFilters = z
  .object({
    type: createZodArrayable(z.enum(odStatusFilesTypeValues)),
    file_name: createZodArrayable(ZodTrimmedString),
  })
  .partial();

export const getB2bStatusFilesSortColumnValues: (keyof B2bStatusFileOneResponse)[] = [
  'id',
  'file_name',
  's3_path',
  'status',
  'created_at',
];

export const ZodGetB2bStatusFilesQuery = buildZodBoListQueryParsed(
  ZodFilters,
  getB2bStatusFilesSortColumnValues,
  { range: [0, 5] },
);

const ZodB2bStatusFileOneResponse = z.object({
  id: ZodId,
  s3_path: ZodTrimmedString.nullable(),
  s3_url: ZodTrimmedString.nullable(),
  file_name: ZodTrimmedString,
  status: z.enum(odStatusFilesStatusValues),
  type: z.enum(odStatusFilesTypeValues),
  created_at: z.date(),
  updated_at: z.date(),
});

export type B2bStatusFileOneResponse = z.TypeOf<typeof ZodB2bStatusFileOneResponse>;

export type GetB2bStatusFilesQuery = BoListQueryBase<
  z.TypeOf<typeof ZodFilters>,
  (typeof getB2bStatusFilesSortColumnValues)[number]
>;

export const getB2bStatusFilesEndpoint = endpoint({
  method: 'GET',
  queryParams: ZodGetB2bStatusFilesQuery,
  responseBody: z.array(ZodB2bStatusFileOneResponse),
});

export type GetB2bStatusFilesEndpoint = GetEndpointType<typeof getB2bStatusFilesEndpoint>;
